import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import Card from '../Card';
import { StyledIcon } from '../../RoundIcon/styles';
import { StyledTag } from '../../Tag/styles';

export const StyledResourcesPreviewBlock = styled.article`  
  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin: 6rem 11rem 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) and (max-width: 1580px) {
    margin: 6rem 5rem 0;
  }
`;

export const StyledCards = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleBase')};

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 50px;
    grid-row-gap: 50px;
  }
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 343px;
  padding-bottom: 36px;

  justify-self: center;

  & > * {
    margin-left: 20px;
    margin-right: 20px;
  }
  
  h2 {
    font-weight: 500;
    font-size: 19px;
    line-height: 30px;
    margin-bottom: 13px;
  }

  .resource-card__image-container{
    height: 182px;
    overflow: hidden;
    background: #EBF2FF;
    margin: 0;

    .gatsby-image-wrapper{
      height:100%;
    }
  }

  .resource-card__type-and-length {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 35px;

    .resource-card__length {
      font-style: italic;
      font-size: 14px;
      font-weight: 300;
    }
  }

  .resource-card__excerpt {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 300;

    p {
      margin-bottom: 0;
    }
  }

  .resource-card__cta-wrapper {
    margin-top: auto;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    &:nth-child(even) {
      justify-self: start;
    }
    &:nth-child(odd) {
      justify-self: end;
    }
  }
`;


export const StyledResourceCardType = styled.div`
  display: flex;
  color: ${props => props.color};
  font-size: 14px;
  text-transform: uppercase;

  .resource-dot {
    height: 28px;
    width: 28px;
    display: inline-block;
    margin-right: 11px;
  }
  
  div {
    display: flex;
    align-items: center;
    font-weight: 500;
  }
  `